export const SET_ITEMS = "SET_ITEMS";

export const SET_ISLOADING = "SET_ISLOADING";

export const SET_USER = "SET_USER";

export const SET_STATUS = "SET_STATUS";

export const SET_FOOD = "SET_FOOD";

export const GET_CATEGORIES = "GET_CATEGORIES"

export const SET_FOODLOADING = "SET_FOODLOADING"

export const GET_CITIES = "GET_CITIES";

export const GET_HOTEL = "GET_HOTEL";

export const GET_CURRENT_HOTEL = "GET_CURRENT_HOTEL";

export const GET_HOTEL_DETAILS = "GET_HOTEL_DETAILS";

export const CITY_NAME = "CITY_NAME"

export const GET_PAGE = "GET_PAGE"

export const GET_CATEGORY = "GET_CATEGORY"

export const GET_QUERY = "GET_QUERY"

export const GET_REVIEWS = "GET_REVIEWS"

export const GET_FAV = "GET_FAV"

export const GET_FAV_RES = "GET_FAV_RES"

export const DEL_FAV = "DEL_FAV"

export const DEL_ID = "DEL_ID"

export const EMPTY_FAV = "EMPTY_FAV"

export const EMPTY_FAV_ID = "EMPTY_FAV_ID"